import { ReactElement, useMemo } from 'react';

import { VisitTemplate, VisitTemplateQuery } from '@dreryk/egabinet-visit-frontend-api';

import { TextInput } from '@dreryk/react-components';
import { TranslatableText, ValidationRules } from '@dreryk/react-common';
import { performCqrsQueryExists } from '@dreryk/command-query-react-common';
import { Slot } from '@dreryk/watermelon';

import { FormsTemplates } from '~libs.desktop.shared.user-templates.forms';

import { visitTemplatesTranslationKeys } from '../../../translations';
import { VisitTemplateFormBean, VisitTemplateFormController } from '../VisitTemplateForm.types';

const useValidationRules = (template: VisitTemplate | undefined): ValidationRules<VisitTemplateFormBean> => {
   const validate = async (data: unknown): Promise<TranslatableText | undefined> => {
      const currentName = data as string | null;
      if (currentName) {
         const currentNameOccupied = await performCqrsQueryExists(() => {
            const query = new VisitTemplateQuery();
            query.name = Slot.of(currentName);
            return query;
         });
         if (currentNameOccupied) {
            return visitTemplatesTranslationKeys.templateNameOccupied;
         }
      }
      return undefined;
   };
   return useMemo(
      () => ({
         maxLength: 60,
         required: true,
         validate: FormsTemplates.isItemEmpty(template) ? validate : undefined,
      }),
      [template]
   );
};

type VisitTemplateFormTemplateNameTextInputProps = Pick<VisitTemplateFormController, 'register'> & {
   template: VisitTemplate | undefined;
};

export const VisitTemplateFormTemplateNameTextInput = (
   props: VisitTemplateFormTemplateNameTextInputProps
): ReactElement => {
   const validationRules = useValidationRules(props.template);
   return (
      <TextInput
         label={visitTemplatesTranslationKeys.templateName}
         placeholder={visitTemplatesTranslationKeys.enterTemplateName}
         controller={props.register('name', validationRules)}
         testId={'templateName'}
      />
   );
};
